import _ from "lodash";
import {
  Button,
  IconButton,
  Stack,
  Typography,
  Paper,
  SvgIcon,
  Divider,
} from "@mui/material";
import {
  ContentCopy as ContentCopyIcon,
  ArrowBackIosOutlined as ArrowBackIosOutlinedIcon,
} from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import { Alert, LoadingSpinner } from "../../../../utils";
import PrintableQr from "./PrintableQr";
import { useApi, useNavigate } from "../../../../utils/hooks";
import TitleHeadSess from "../../../../utils/TitleHeadSess";
import { useLocation } from "react-router-dom";

const ShareLink = ({ selfRegisterUrl }) => {
  const [copiedLink, setCopiedLink] = useState(false);
  const copiedLinkMessage = "Link copiado al portapapeles";
  const onAlertClose = () => setCopiedLink(false);

  const ButtonCopy = () => {
    return (
      <CopyToClipboard
        text={selfRegisterUrl}
        onCopy={() => setCopiedLink(true)}
      >
        <IconButton>
          <SvgIcon sx={{ color: "primary.main", fontSize: { xs: 18, sm: 20 } }}>
            <ContentCopyIcon />
          </SvgIcon>
        </IconButton>
      </CopyToClipboard>
    );
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: { xs: 18, sm: 24 },
          color: "text.black",
          fontFamily: `"Inter", sans-serif`,
        }}
      >
        Compartile este link al paciente para que se registre en tu recetario:
      </Typography>

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{ color: "#606060", fontFamily: `"Inter", sans-serif` }}
        >
          Link Recetario:
        </Typography>

        <Stack sx={{ display: { xs: "block", sm: "none" }, mr: 0.5 }}>
          <ButtonCopy />
        </Stack>
      </Stack>

      <Stack direction="row" paddingX="5px" alignItems="center">
        <Typography
          sx={{
            fontSize: { xs: 12, sm: 14 },
            color: "#606060",
            fontFamily: `"Inter", sans-serif`,
            fontWeight: 700,
            wordBreak: "break-all",
            overflowWrap: "break-word",
            maxWidth: "100%",
          }}
        >
          {selfRegisterUrl}
        </Typography>
        <Stack sx={{ display: { xs: "none", sm: "block" }, mr: 0.5 }}>
          <ButtonCopy />
        </Stack>
      </Stack>
      <Alert
        severity="success"
        message={copiedLinkMessage}
        show={copiedLink}
        duration={3000}
        onClose={onAlertClose}
      />
    </>
  );
};

const ShareQRCode = ({ selfRegisterUrl, componentRef }) => {
  return (
    <>
      <Typography sx={{ color: "#606060", fontFamily: `"Inter", sans-serif` }}>
        Escanear QR:
      </Typography>
      <div style={{ maxWidth: "200px", margin: "0 auto", marginTop: "1rem" }}>
        <QRCode
          style={{ width: "100%", height: "auto" }}
          value={selfRegisterUrl}
        />
        <PrintableQr url={selfRegisterUrl} reference={componentRef} />
      </div>
    </>
  );
};

const ShareRegistrationDialog = ({ open }) => {
  const api = useApi();
  const [token, setToken] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = window.location.origin;
  const selfRegisterUrl =
    token && baseUrl + `/patients/selfRegister?token=${token}`;

  const { url } = location.state || {
    url: "/",
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    api.patientRegistrationToken().tap(setToken);
  }, []);

  if (!token)
    return (
      <Stack alignItems="center">
        <LoadingSpinner isLoading />
      </Stack>
    );

  if (token)
    return (
      <Stack
        spacing="1rem"
        sx={{
          p: { xs: "1rem", sm: "2rem" },
          mt: { xs: "1rem" },
          width: "100%",
        }}
      >
        <TitleHeadSess
          title={"Nuevo Paciente |"}
          name={"Link para Auto-registro  "}
          urlRedirect={url}
        />
        <Paper
          variant="outlined"
          width="100%"
          sx={{
            p: { xs: "20px 10px", sm: "20px 80px" },
            borderRadius: 3,
            mb: 7,
          }}
        >
          <Stack p="2rem" spacing="1.5rem">
            <>
              <ShareLink selfRegisterUrl={selfRegisterUrl} />
              <Divider />
              <ShareQRCode
                selfRegisterUrl={selfRegisterUrl}
                componentRef={componentRef}
              />
            </>
          </Stack>
        </Paper>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate(url)}
            sx={{ mr: 1 }}
          >
            <SvgIcon sx={{ fontSize: 16, mr: 1 }}>
              <ArrowBackIosOutlinedIcon />
            </SvgIcon>
            Volver
          </Button>
          <Button variant="contained" onClick={handlePrint} sx={{ ml: 1 }}>
            Imprimir
          </Button>
        </Stack>
      </Stack>
    );
};

export default ShareRegistrationDialog;
